import VacanciesList from './VacanciesList.vue';

export default VacanciesList;



// WEBPACK FOOTER //
// ./src/pages/vacancies/list/index.ts